export const GET_USERINFO = 'GET_USERINFO'
export const RECORD_USERINFO = 'RECORD_USERINFO'
export const RECORD_TOKENINFO = 'RECORD_TOKENINFO'
export const RECORD_MENULIST = 'RECORD_MENULIST'
export const SET_PreOrderCount = 'SET_PreOrderCount'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js